export default {
  units: {
    itself: 'Unități',
    symbol: 'Simbol',
    symbolRequired: 'Simbolul este necesar',
    editUnit: 'Editați unitatea',
    createUnit: 'Creați o unitate',
  },
};
